"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _courseItem = _interopRequireDefault(require("@/components/courseItem.vue"));
var _xnfzItem = _interopRequireDefault(require("@/components/xnfzItem.vue"));
var _courseTwo = _interopRequireDefault(require("@/components/courseTwo.vue"));
var _courseItemResource = _interopRequireDefault(require("@/components/courseItemResource.vue"));
var _winCourse = _interopRequireDefault(require("@/components/winCourse.vue"));
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
var _public = require("@/api/public/public");
var _news = require("@/api/news/news");
var _recommendCourse = require("@/api/recommendCourse");
var _index = require("@/api/virtualSimulationClass/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import "../index.less";
var _default = exports.default = {
  components: {
    CourseItem: _courseItem.default,
    XnfzItem: _xnfzItem.default,
    Banner: _banner.default,
    Search: _search.default,
    WinCourse: _winCourse.default,
    courseItemResource: _courseItemResource.default,
    CourseTwo: _courseTwo.default,
    Nav: _nav.default
  },
  filters: {
    date: function date(val) {
      return val.slice(0, 10);
    }
  },
  data: function data() {
    return {
      actNum: 0,
      curType: 0,
      listBookData: [],
      listData: [],
      //moni
      newsItem: [],
      CountryList: [],
      newTypeList: [],
      tjkList: [],
      zykList: [],
      courseList: [],
      openCourseList: [],
      virtualList: [],
      teacherList: [],
      query: {
        isPut: 1,
        pageNum: 1,
        pageSize: 8,
        provinceId: this.$store.getters.provinceId,
        courseName: "",
        majorName: ''
      }
    };
  },
  methods: {
    getRecommendList: function getRecommendList() {
      var _this = this;
      (0, _recommendCourse.recommendList)({
        pageNum: 1,
        pageSize: 8
      }).then(function (res) {
        _this.tjkList = res.rows;
      });
    },
    toSsearch: function toSsearch(e) {
      console.log("dianji", e);
      this.query.courseName = e.courseName;
      this.query.majorName = e.majorName;
      this.getCourseList();
      this.getZykList();
      // this.getOpenCourseList();
      // this.getList();
      // this.getTextbookList();
      this.getCountryList();
      // this.getTeacherList()
    },
    toSecond: function toSecond(url) {
      this.$router.push(url);
    },
    // 专业与课程切换
    tabChange: function tabChange(index) {
      this.actNum = index;
      // alert('111')
    },
    // 搜索
    handleSearch: function handleSearch() {},
    // 获取新闻类型
    getNewsType: function getNewsType() {
      var _this2 = this;
      (0, _news.newsTypeByCode)({
        param: this.prCode
      }).then(function (res) {
        if (res.data.length > 0) {
          _this2.newTypeList = res.data;
          _this2.findNews(_this2.newTypeList[0].id);
        }
      });
    },
    // 获取首页精品在线课程
    getCourseList: function getCourseList() {
      var _this3 = this;
      (0, _index.getReceptionList)({
        courseName: this.query.courseName,
        courseType: "1",
        schoolId: "",
        pageNum: 1,
        pageSize: 8,
        // projectLevel: this.projectLevel,
        provinceId: this.$store.getters.provinceId,
        show_status: 1,
        majorName: this.query.majorName
      }).then(function (res) {
        var data = res.data;
        console.log("data", data);
        _this3.courseList = data.list;
      });
    },
    getCountryList: function getCountryList() {
      var _this4 = this;
      //国家规划教材数字课程
      (0, _index.getReceptionList)({
        courseName: this.query.courseName,
        courseSource: "",
        pageNum: 1,
        pageSize: 8,
        projectLevel: "",
        provinceId: this.$store.getters.provinceId,
        courseType: '3',
        schoolId: '',
        majorName: this.query.majorName
      }).then(function (res) {
        _this4.CountryList = res.data.list;
      });
    },
    //获取专业资源库
    getZykList: function getZykList() {
      var _this5 = this;
      (0, _index.webList)({
        emceeCompanyname: "",
        ids: [],
        industry: "",
        industryDetail: "",
        majorLevel: "",
        name: "",
        onState: 1,
        pageNum: 1,
        pageSize: 8,
        provinceId: this.$store.getters.provinceId,
        schoolId: "",
        keyWord: this.query.courseName,
        majorName: this.query.majorName
      }).then(function (res) {
        for (var i in res.data.list) {
          if (res.data.list[i].previewPic && res.data.list[i].previewPic.indexOf('?') !== -1) {
            res.data.list[i].previewPic = res.data.list[i].previewPic.substring(0, res.data.list[i].previewPic.indexOf('?'));
          }
        }
        _this5.zykList = res.data.list;
      });
    },
    getOpenCourseList: function getOpenCourseList() {
      var _this6 = this;
      (0, _index.getReceptionList)({
        courseName: this.query.courseName,
        courseType: "",
        schoolId: "",
        pageNum: 1,
        pageSize: 8,
        courseTypeList: ["2", "3", "4", "5", "6"],
        provinceId: this.$store.getters.provinceId,
        show_status: 1,
        majorName: this.query.majorName
      }).then(function (res) {
        var data = res.data;
        _this6.openCourseList = data.list;
      });
    },
    tabs: function tabs(index, id) {
      this.curType = index;
      this.newsItem = [];
      this.findNews(id);
    },
    // 根据不同类型ID查询不同省份新闻
    findNews: function findNews(id) {
      var _this7 = this;
      (0, _news.newsListByCodeAndType)({
        code: this.prCode,
        newsTypeId: id,
        pageNum: 1,
        pageSize: 8
      }).then(function (res) {
        _this7.newsItem = res.data.list;
      });
    },
    // 更多
    lookMoreBtn: function lookMoreBtn(v) {
      this.$router.push(v);
    },
    // 查看详情
    lookDetail: function lookDetail(e) {
      if (e.newsUrl) {
        window.open(e.newsUrl);
      } else {
        this.$router.push({
          path: "/newsDetail",
          query: {
            newsType: "news",
            curIndex: this.curType,
            id: e.id
          }
        });
      }
    }
  },
  created: function created() {
    // if(this.$router.query)
    // console.log(this.$router.query.courseName,'this.$router.query');
    this.getRecommendList();
    this.getCourseList();
    this.getZykList();
    this.getCountryList();
  }
};